<template>
    <div class="mb-4">
        {{ translate("Select Picture Book Type") }}

        <div class="form-group mt-4 row">
            <div class="col-xl-12 dm-checkbox-email-options checkbox-list">
                <label
                    class="checkbox"
                    v-for="subSubCategory in sub_sub_categories"
                    :key="'taxonomy-sub-sub-category-' + subSubCategory.id"
                >
                    <input
                        type="radio"
                        name="dm-picture-book-type"
                        :value="subSubCategory.id"
                        v-model="submission.sub_sub_category_id"
                        @change="saveSubmission()"
                    />
                    <span></span>{{ subSubCategory.name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";

export default {
    props: ["sub_categories", "sub_sub_categories"],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["submission"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveSubmission"]),
    },
};
</script>
